import {combineReducers} from 'redux';
import {analyticsReducer, AnalyticsReducerState, preloadedState as analyticsReducerPreloadedState} from './reducer/analytics.reducer';
import {modalReducer, ModalReducerState, preloadedState as modalReducerPreloadedState} from './reducer/modal.reducer';
import {
    preloadedState as presentationReducerPreloadedState,
    presentationReducer,
    PresentationReducerState,
} from './reducer/presentation.reducer';
import {preloadedState as runFileReducerPreloadedState, runFileReducer, RunFileReducerState} from './reducer/runfile.reducer';
import {preloadedState as spinnerReducerPreloadedState, spinnerReducer, SpinnerReducerState} from './reducer/spinner.reducer';
import {layoutReducer, LayoutReducerState, preloadedState as layoutReducerPreloadedState} from './reducer/layout.reducer';
import {
    preloadedState as slidesAnalyticsPreloadedState,
    slidesAnalyticsReducer,
    SlidesAnalyticsReducerState,
} from './reducer/slidesAnalytics.reducer';
import {preloadedState as roomRunFilePreloadedState, roomRunFileReducer, RoomRunFileReducerState} from './reducer/roomRunFile.reducer';
import {
    preloadedState as questionToastPreloadedState,
    questionToastReducer,
    QuestionToastReducerState,
} from './reducer/questionToast.reducer';
import {authReducer, AuthReducerState, preloadedState as authReducerPreloadedState} from './reducer/auth.reducer';
import {
    connectionStatusReducer,
    ConnectionStatusReducerState,
    preloadedState as connectionStatusPreloadedState,
} from './reducer/connectionStatus.reducer';
import {roomProtectionPreloadedState, roomProtectionReducer, RoomProtectionState} from './reducer/roomProtection.reducer';
import {preloadedState as timerReducerPreloadedState, timerReducer, TimerReducerState} from './reducer/timer.reducer';

const reducer = combineReducers({
    presentationReducer,
    runFileReducer,
    analyticsReducer,
    modalReducer,
    spinnerReducer,
    layoutReducer,
    slidesAnalyticsReducer,
    roomRunFileReducer,
    questionToastReducer,
    authReducer,
    connectionStatusReducer,
    roomProtectionReducer,
    timerReducer,
});

export interface AppState {
    presentationReducer: PresentationReducerState;
    runFileReducer: RunFileReducerState;
    analyticsReducer: AnalyticsReducerState;
    modalReducer: ModalReducerState;
    spinnerReducer: SpinnerReducerState;
    layoutReducer: LayoutReducerState;
    slidesAnalyticsReducer: SlidesAnalyticsReducerState;
    roomRunFileReducer: RoomRunFileReducerState;
    questionToastReducer: QuestionToastReducerState;
    authReducer: AuthReducerState;
    connectionStatusReducer: ConnectionStatusReducerState;
    roomProtectionReducer: RoomProtectionState;
    timerReducer: TimerReducerState;
}

export const reducerPreloadedState: AppState = {
    presentationReducer: presentationReducerPreloadedState,
    runFileReducer: runFileReducerPreloadedState,
    analyticsReducer: analyticsReducerPreloadedState,
    modalReducer: modalReducerPreloadedState,
    spinnerReducer: spinnerReducerPreloadedState,
    layoutReducer: layoutReducerPreloadedState,
    slidesAnalyticsReducer: slidesAnalyticsPreloadedState,
    roomRunFileReducer: roomRunFilePreloadedState,
    questionToastReducer: questionToastPreloadedState,
    authReducer: authReducerPreloadedState,
    connectionStatusReducer: connectionStatusPreloadedState,
    roomProtectionReducer: roomProtectionPreloadedState,
    timerReducer: timerReducerPreloadedState,
};

export default reducer;
